import { createAction } from 'redux-act';

export const togglePromoKeyboardShortcuts = createAction(
  'UI_PERSIST_PROMO_KEYBOARD_SHORTCUTS_TOGGLE'
);

export const setUiPersist = createAction('UI_PERSIST_SET');
